import { Injectable } from "@angular/core";
import { LocalStorage } from "../auth/local.storage";
import { AccountService } from "../auth/account.service";
import { WolandBaseDriveAuthService } from "./base-drive.auth.service";
import { environment } from "src/environments/environment";
import { AuthModel, CLOUD_PKCE_VERIFIER_KEY } from "../cloud-storage/cloud-auth-base.service";
import { WolandCloudDriveServerConnectionService } from "./woland-cloud-drive-server-connection";
import { CloudServiceEnum } from "../cloud-storage/enums";

@Injectable({
    providedIn: 'root'
})

export class WolandGoogleDriveAuthService extends WolandBaseDriveAuthService {
    constructor(
        protected readonly localStorage: LocalStorage,
        protected readonly accountService: AccountService,
        protected readonly wolandCloudDriveServerConnectionService: WolandCloudDriveServerConnectionService,
    ) {
        super(localStorage, accountService, wolandCloudDriveServerConnectionService);
    }

    async authorize(): Promise<void> {
        this.logout();

        const { verifier, challenge, method } = this.generatePkce();
        this.localStorage.set(CLOUD_PKCE_VERIFIER_KEY, verifier);

        const googleAuthUrl = environment.woland.googleDrive.authUrl;
        const clientId = environment.woland.googleDrive.clientId;
        const redirectUri = `${window.location.origin}/${environment.woland.googleDrive.redirectUri}`;
        const responseType = environment.woland.googleDrive.responseType;
        const scope = this.getScope();

        const options: AuthModel = {
            //localStorageKey should be empty in this case, setup after request token from server
            localStorageKey: '',
            url: `${googleAuthUrl}?scope=${scope}&access_type=offline&include_granted_scopes=true` +
                 `&response_type=${responseType}&redirect_uri=${redirectUri}&client_id=${clientId}` +
                 `&prompt=consent&code_challenge=${challenge}&code_challenge_method=${method}`,
            windowName: 'GoogleDriveAuthPopup'
        };

        await super.authorizePopup(options, false);
    }

    async unAttachDrive(): Promise<void> {
        this.logout();
    }

    getScope(): string {
        const scope = environment.woland.googleDrive.scope;
        return encodeURI(scope.join(' '));
    }

    isConnected() {
        let authInfo = this.wolandDriveInfo;
        if (authInfo && authInfo.cloudType === CloudServiceEnum.GoogleDrive) {
            return true;
        }
        return false;
      }
}
